
const connectorTypeOptions = [
  { name: "AC Type 1", value: "AC Type 1" },
  { name: "AC Type 2", value: "AC Type 2" },
  { name: "CCS Type 2", value: "CCS Type 2" },
  { name: "CHAdeMO", value: "CHAdeMO" },
  { name: "3 Pin Socket (16A - 230V)", value: "DOMESTIC_D" },
];

const connectorFormatOptions = [
  { name: "SOCKET", value: "SOCKET" },
  { name: "CABLE", value: "CABLE" },
];

// Format-based type mapping
export const formatTypeMapping = {
  SOCKET: [{ name: "3 Pin Socket (16A - 230V)", value: "DOMESTIC_D" }],
  CABLE: [
    { name: "AC Type 1", value: "AC Type 1" },
    { name: "AC Type 2", value: "AC Type 2" },
    { name: "CCS Type 2", value: "CCS Type 2" },
    { name: "CHAdeMO", value: "CHAdeMO" },
  ],
};

export const updateChargePointConnectorSelectOptions = [
  {
    label: "Connector/Gun Number",
    placeholder: "Connector/Gun Number",
    name: "EvseSerialId",
    type: "number",
  },
  {
    label: "Format",
    placeholder: "Evse Format",
    name: "Format",
    type: "select",
    options: connectorFormatOptions,
  },
  {
    label: "Connector Type",
    placeholder: "Connector Type",
    name: "Standard",
    type: "select",
    options: connectorTypeOptions,
  },
];

export const createChargePointConnectorSelectOptions = [
  {
    label: "Connector/Gun Number",
    placeholder: "Connector/Gun Number",
    name: "EvseSerialId",
    type: "input",
  },
  {
    label: "Format",
    placeholder: "Evse Format",
    name: "Format",
    type: "select",
    options: connectorFormatOptions,
  },
  {
    label: "Type of Evse",
    placeholder: "Type of Evse",
    name: "Standard",
    type: "select",
    options: connectorTypeOptions,
  },
];
